import { useMemo, useState } from "react";

import { EditMode } from "../../../../types/edit_mode";
import { BookingRowsContextType } from "./booking_rows_context";
import { useSelectMode, UseSelectModeType } from "./use_select_mode/use_select_mode";
import { useWallPlannerEditMode, WallPlannerEditModeType } from "./use_wall_planner_edit_mode";

export type UseEditModeType = {
  editMode: EditMode;
  setEditMode: (mode: EditMode) => void;
  isEditModeEnabled: boolean;
  selectEditMode: UseSelectModeType;
  wallPlannerEditMode: WallPlannerEditModeType;
};

type UseEditMode = Pick<BookingRowsContextType, "bookingsByRowKey">;

export const useEditMode = ({ bookingsByRowKey }: UseEditMode): UseEditModeType => {
  const [editMode, setEditMode] = useState<EditMode>(EditMode.Disabled);
  const selectModeState = useSelectMode({
    bookingsByRowKey,
    editMode
  });

  const wallPlannerEditModeState = useWallPlannerEditMode();

  const isEditModeEnabled = useMemo(() => editMode !== EditMode.Disabled, [editMode]);

  return {
    editMode,
    setEditMode,
    isEditModeEnabled,
    selectEditMode: selectModeState,
    wallPlannerEditMode: wallPlannerEditModeState
  };
};
